/* global __DEV__ */

const trace = (msg, ...optionalParams) => {
  if (__DEV__ || process.env.TEST) {
    console.log(new Date(), msg, ...optionalParams);
  }
};

export default trace;
